export default __webpack_public_path__ + "static/AoU-8e1f6f1a85f1f2ccf3ea0909a1757355.gif";